module.exports = __webpack_public_path__ + "img/logo.2387368d.svg";